// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CebC","expireSoon":"styles_expireSoon__3tyQf"};